import React from 'react';
import NavBar from "../NavBar";
import Header from "./Header";

const TuteeMain = () => {
	return (
    <>
      <NavBar />
			<Header />
    </>
  );
};
export default TuteeMain;